import React from 'react';
import styles from './CustomAccordion.module.scss';
import cls from 'classnames';
import {ExpandLess, ExpandMore, ChevronRight} from "@mui/icons-material";
const CustomAccordion = ({ children, defaultOpen = false, onOpenChange, headerContent }) => {
    const [open, setOpen] = React.useState(defaultOpen);
    return (
        <div className={cls(styles.customAccordion, {[styles.open]: open})}>
            <div
                className={styles.accordionHeader}
                onClick={() => {
                    setOpen(!open);
                    if (onOpenChange) {
                        onOpenChange(!open);
                    }
                }}
            >
                {
                    !open ? <ChevronRight className={styles.icon}/> : <ExpandLess className={styles.icon}/>
                }
                {headerContent}
            </div>
            {open && <div className={styles.accordionContent}>{children}</div>}
        </div>
    );
}
export default CustomAccordion;